function Route ( path, name, meta = null )
{
	let result = {};
	
	result.path = path;
	result.name = name;
	result.component = () => import( '@/views/' + name + '.vue' );
	result.meta = null;
	
	if ( meta )
		result.meta = meta;
	
	return result;
}


export const routes =
[
	// {
	// 	path: '/',
	// 	name: 'root',
	// 	meta:
	// 	{
	// 		security: // si está presente, significa que necesita un usuario identificado
	// 		{
	// 			roles: // lista de permisos específicos que necesita la página
	// 			[
	//				'domain:path:role'
	// 			]
	// 		}
	// 	}
	// },
	Route( '/login', 'Login', { redirect_if_logged_in: 'Main' } ),
	Route( '/register', 'Register', { redirect_if_logged_in: 'Main' } ),
	
	Route( '/', 'Main', { redirect_if_logged_out: 'Login' } ),
	
	Route( '/profile', 'Profile', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/details', 'Profile_personal_details', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/vehicles', 'Profile_vehicles', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/password', 'Profile_change_password', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/reservations', 'Profile_reservations', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/packages', 'Profile_packages', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/contracts', 'Profile_contracts', { redirect_if_logged_out: 'Login' } ),
	Route( '/profile/payment/cards', 'Profile_payment_cards', { redirect_if_logged_out: 'Login' } ),
	
	Route( '/reservations/new/covered', 'Reservations_new_covered', { redirect_if_logged_out: 'Login' } ),
	
	Route( '/:pathMatch(.*)*', 'Error404' )
];
